"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOMAIN = void 0;
const COPY_1 = require("../messages/COPY.js");
exports.DOMAIN = {
    MESSAGE: COPY_1.MESSAGES_COPY.INVALID_OIDC_DOMAIN,
    PATTERN: /https:\/\/.*?\.[a-z]{2,4}/u
};
//# sourceMappingURL=DOMAIN.js.map